// The shared text normalizer for every kind of GROUNDING Otto does — matching a phrase against page labels,
// synonyms, column names, entity nouns. Lowercase, non-alphanumerics collapsed to single spaces, trimmed.
//
// It lives here, alone and dependency-free, for two reasons:
//
//   1. It used to live in navCatalog.js, which imports `checkPermission` and the permissions map AT MODULE
//      LOAD. Anything wanting to normalize a string inherited that — which is why three test files mock
//      permissions purely to compare two strings, and why fieldMention.js wrote its own copy rather than
//      import it (see its `normalizeLabel` comment, which names this exact cost).
//   2. It let the page REGISTRY and the DESTINATION catalog form an import cycle: page ranking needs the
//      registry's families, the registry needs a normalizer, and the normalizer lived in the catalog that
//      wants to rank. With it here the graph is a line — navCatalog -> pageRanking -> pageManifest -> here.
//
// navCatalog still RE-EXPORTS it, so every existing `import { normalizeText } from ".../navCatalog"` keeps
// working and this extraction changes no call site. `fieldMention.normalizeLabel` stays separate on purpose:
// it adds a plural fold this one deliberately does not.
export const normalizeText = s =>
    String(s == null ? "" : s)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
